import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import FeaturedVehicles from "./components/FeaturedVehicles";
import MapSection from "./components/MapSection";
import AppDownloadBanner from "./components/AppDownloadBanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <HowItWorks />
      <FeaturedVehicles />
      <MapSection />
      <AppDownloadBanner />
      <Footer />
    </div>
  );
}
